import React, { useState } from 'react';
import { useNavigationPaneContext } from '@website-editor/context/NavigationPaneContext/NavigationPane.context';
import { useEventCallback } from '@shared/utils/hooks/useEventCallback';
import { Photos } from '@withjoy/joykit/icons';
import { useTranslation } from '@shared/core';
import { LayoutEditComponentListItem } from '@website-editor/features/custom-page/components/LeftPanelLayouts/LayoutEditComponentListItem';
import { WebsiteEditorPhotoComponentFragment } from '@graphql/generated';
import { useCustomComponentStateContext } from '@website-editor/features/custom-page/context/CustomComponentStateContext/CustomComponentState.context';
import { PhotoProps } from '../../Photo';
import { PHOTO_ACTIONS } from '../../Photo.constants';
import { TextV2 } from '@withjoy/joykit';

export const PhotoEditListItem: React.FC<PhotoProps> = props => {
  const { componentData, isLastItem, sortable } = props;
  const [isHover, setIsHover] = useState(false);
  const { t } = useTranslation('websiteEditor');
  const { navigateToScreen } = useNavigationPaneContext();
  const { setCustomComponentBlockData, setShowDeletePopup, setDeleteComponentDetails } = useCustomComponentStateContext<WebsiteEditorPhotoComponentFragment>();
  const photoTrans = t('customPage', 'photo');

  const handleEdit = useEventCallback(() => {
    setCustomComponentBlockData(componentData);
    navigateToScreen(PHOTO_ACTIONS.PHOTO_EDIT);
  });

  const handleDeleteClick = useEventCallback(() => {
    if (componentData?.id) {
      setShowDeletePopup(true);
      setDeleteComponentDetails({
        id: componentData.id,
        title: photoTrans.deleteTitle(),
        subTitle: photoTrans.deleteSubtitle(),
        deleteCta: photoTrans.deleteCta(),
        cancelCta: photoTrans.cancelCta(),
        successMessage: photoTrans.deleteComponentSuccess(),
        errorMessage: photoTrans.deleteComponentError(),
      });
    }
  });

  return (
    <LayoutEditComponentListItem
      title={<TextV2 typographyVariant="button2">{photoTrans.photoCardHeader()}</TextV2>}
      isDragActive={sortable?.isDragActive ?? false}
      dragItemId={sortable?.dragItemId ?? ''}
      isLastItem={isLastItem}
      height={sortable?.itemSize}
      itemId={componentData.id}
      icon={<Photos size={32} />}
      isHover={isHover}
      setIsHover={setIsHover}
      handleEdit={handleEdit}
      handleDelete={handleDeleteClick}
      thumbnailUrls={componentData.photo?.url ? [componentData.photo?.url] : []}
      cardPaddingY={5}
    />
  );
};
